import { Dropdown } from 'primereact/dropdown'
import React from 'react'

export default function P300Search({data,dataList,setData,setDataChart}) {

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });

        setDataChart({
            ...data,
            [`${key}`]: val,
        });
    };


    return (
        <div className="p-fluid p-formgrid p-grid">
            {/* <div className="p-field p-col-12 p-md-4"></div> */}
            <div className="p-field p-col-12 p-md-6">
            </div>
            <div className="p-field p-col-12 p-md-3" style={{textAlign:'right'}}>
                <label htmlFor="">งบประมาณ</label>
            </div>
            <div className="p-field p-col-12 p-md-3" >
                <Dropdown id="requestType" 
                    value={data.budgetType} 
                    onChange={(e) => onInputTextChange(e, "budgetType")} 
                    options={dataList} 
                    optionLabel="budgetTypeDesc" 
                    optionValue="budgetTypeCode"
                    placeholder="เลือก" 

                />
            </div>
            
        </div>
    )
}
